import { render, staticRenderFns } from "./GameLink.vue?vue&type=template&id=bf12f0bc&scoped=true"
import script from "./GameLink.vue?vue&type=script&lang=js"
export * from "./GameLink.vue?vue&type=script&lang=js"
import style0 from "./GameLink.vue?vue&type=style&index=0&id=bf12f0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf12f0bc",
  null
  
)

export default component.exports